import { Autocomplete } from "@mui/material"
import type { AutocompleteProps } from "@mui/material/Autocomplete"
import type { ReactElement } from "react"
import React from "react"

interface TypeaheadInputProps<T> extends AutocompleteProps<T, true, true, false> {
  id?: string
}

const TypeaheadInput = <T,>({ id, ...rest }: TypeaheadInputProps<T>): ReactElement => {
  return <Autocomplete freeSolo id={id} filterOptions={(x: T[]) => x} {...rest} />
}

export default TypeaheadInput
